<script>
import Layout from "@layouts/form";
import Agenda from "@forms/Agenda";

export default {
  page: {
    title: "Detalhes | Agenda"
  },
  components: { Layout, Agenda },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Agenda",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Agenda",
          href: "/Agenda"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Agenda :editable="editable"></Agenda>
    </div>
  </Layout>
</template>
